import type { ClusterDriftEntry } from '@/types/simulation'

interface Props {
  clusters: ClusterDriftEntry[]
}

export function ClusterDriftCard({ clusters }: Props) {
  const fmtPct = (s: string) => `${(Number(s) * 100).toFixed(1)}%`
  return (
    <div className="border border-hairline bg-panel p-4">
      <div className="tracked-caps mb-3 text-[10px] text-faint">Cluster-Drift</div>
      <div className="space-y-1 text-sm text-ink">
        {clusters.length === 0 && <div className="text-muted">Keine Cluster-Rules aktiv.</div>}
        {clusters.map((c) => (
          <div key={c.cluster_label} className="flex justify-between">
            <span>{c.cluster_label}</span>
            <span className="font-mono">
              <span className="text-muted">{fmtPct(c.pct_before)}</span>
              <span className="text-faint"> → </span>
              <strong className="text-ink">{fmtPct(c.pct_after)}</strong>{' '}
              <span className={c.exceeds_cap_after ? 'text-loss' : 'text-gain'}>
                {c.exceeds_cap_after ? '⚠' : '✓'}
              </span>
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
